export const UserAlreadyExist = "UserAlreadyExistException";
export const RefreshTokenExpired = "RefreshTokenExpiredException";
export const InvalidRegistrationCode = "ValidRegistrationCodeValidator";
export const IsAllowedDomainValidator = "IsAllowedDomainValidator";
